/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum DeliveringMealsBySequenceAliases {
  APPLY_BUTTON = 'apply-button',
  BARCODE_COMPONENT = 'barcode-component',
  CARD_CONTAINER_0 = 'card-container-0',
  CARD_CONTAINER_BODY_0 = 'card-container-body-0',
  CARD_CONTAINER_ZONE_0 = 'card-container-zone-0',
  CARD_CONTAINER_ZONE_1 = 'card-container-zone-1',
  CARD_CONTAINER_ZONE_2 = 'card-container-zone-2',
  CARD_CONTAINER_ZONE_3 = 'card-container-zone-3',
  CLEAN_BUTTON = 'clean-button',
  DATE_TEXT = 'date-text',
  DELIVERING_MEALS = 'delivering-meals',
  DELIVERING_MEALS_DECK = 'delivering-meals-deck',
  DESCRIPTION_TEXT = 'description-text',
  END_DATE_TEXT = 'end-date-text',
  FIELD_BARCODE = 'field-barcode',
  GLOBAL_ACTIONS_0 = 'global-actions-0',
  LAYOUT_DELIVERING_MEALS = 'layout-delivering-meals',
  MAPPER_0 = 'mapper-0',
  MAPPER_DATE = 'mapper-date',
  MAPPER_END_DATE = 'mapper-end-date',
  MAPPER_SERVICE_DESCRIPTION = 'mapper-service-description',
  MAPPER_START_DATE = 'mapper-start-date',
  MAPPER_TYPE_DESCRIPTION = 'mapper-type-description',
  PANEL_0 = 'panel-0',
  START_DATE_TEXT = 'start-date-text',
  TYPE_TEXT = 'type-text',
}
export { DeliveringMealsBySequenceAliases };
